import { useEffect } from 'react';
import ENDPOINT from '../constants/endpoints';
import BasicDialog from '../scenes/Dialog/components/BasicDialog';
import ResponseErrorDialog from '../scenes/Dialog/components/ResponseErrorDialog';
import useApi from './useApi';

const TOKEN_ACTIONS = {
  RESUME_ACCEPT: 'resume_accept',
  RESUME_DECLINE: 'resume_decline',
  CONNECTION_ACCEPT: 'connection_accept',
  CONNECTION_DECLINE: 'connection_decline',
};

export const useTokenAction = (history, callback) => {
  const api = useApi();

  useEffect(() => {
    const params = new URLSearchParams(history.location.search);
    const token = params.get('token');
    const action = params.get('action');

    if (token && action) {
      if (TOKEN_ACTIONS.RESUME_ACCEPT === action) {
        doAction(
          ENDPOINT.ACTION.RESUME_REQUEST_ACCEPT,
          { token },
          'Resume request accepted'
        ).then(() => callback && typeof callback === 'function' && callback());
      }

      if (TOKEN_ACTIONS.RESUME_DECLINE === action) {
        doAction(
          ENDPOINT.ACTION.RESUME_REQUEST_ACCEPT,
          { token },
          'Resume request declined'
        ).then(() => callback && typeof callback === 'function' && callback());
      }

      if (TOKEN_ACTIONS.CONNECTION_ACCEPT === action) {
        doAction(
          ENDPOINT.ACTION.NETWORK.ACCEPT,
          { token },
          'Connection request accepted'
        ).then(() => callback && typeof callback === 'function' && callback());
      }

      if (TOKEN_ACTIONS.CONNECTION_DECLINE === action) {
        doAction(
          ENDPOINT.ACTION.NETWORK.REJECT,
          { token },
          'Connection request declined'
        ).then(() => callback && typeof callback === 'function' && callback());
      }
    }
  }, [history]);

  const doAction = (endpoint, params, message) =>
    new Promise(resolve => {
      api.post(endpoint, params, {
        handleError: response => ResponseErrorDialog({ response }),
        handleSuccess: () => {
          resolve();
          message && BasicDialog({ bodyRender: message });
        },
        handleComplete: () => history.replace(history.location.pathname),
      });
    });
};
